import { apiInstance } from "./api"

const endpoint = "/rider"

export const getRiders = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}`)

  return response.data
}

export const addRider = async data => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const editRider = async (data, mobilePhone) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/${mobilePhone}`, data)

  return response.data
}